import React, { useContext, useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { INSERT_MENTION_COMMAND } from '../InsertMentionPlugin';
import { useParams } from "react-router-dom";
import { getTopicMembers } from "../../../../api/topics";
import { UserContext } from '../../../../functions/Auth';

// mui
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

// icons
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

// types
type TopicMember = {
    userId: number,
    userName: string,
}

type MentionListType = {
    userId: number,
    userName: string,
};

const MentionSelect = () => {
    const [editor] = useLexicalComposerContext();
    const params = useParams();
    const topicId = params.topicId;
    const userInfo = useContext(UserContext);

    // メニューの開閉
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // トピックメンバー取得
    const [topicMembers, setTopicMembers] = useState<TopicMember[]>();
    useEffect(() => {
        if (topicId && userInfo) {
            getTopicMembers(topicId)
                .then((topicMembers) => {
                    setTopicMembers(topicMembers);
                });
        }
    }, [topicId, userInfo]);

    // メンションリストの作成
    const [mentionList, setMentionList] = useState<MentionListType[]|undefined>(undefined);
    useEffect(() => {
        if (userInfo) {
            const filteredMentionList = topicMembers?.filter(item => item.userId !== userInfo.userId);
            setMentionList(filteredMentionList);
        }
    }, [topicMembers, userInfo]);

    const insertMentionInline = (targetUserId: number, targetUserName: string) => {
        editor.dispatchCommand(INSERT_MENTION_COMMAND, { id: targetUserId, name: targetUserName });
    };

    return (
        <>
            <ButtonGroup
                size="small"
                aria-label="small button group"
                sx={{
                    [`& .MuiButtonBase-root`]: {
                        borderColor: (theme) => theme.palette.grey[400],
                        color: (theme) => theme.palette.grey[600],

                    },
                    [`& .MuiSvgIcon-root`]: {
                        fontSize: 18,
                    },
                }}
            >
                <Button
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                >
                    <AlternateEmailIcon />
                </Button>
            </ButtonGroup>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {mentionList?.map((user) => (
                    <MenuItem
                        key={user.userId}
                        onClick={() => {
                            insertMentionInline(user.userId, user.userName);
                            handleClose();
                        }}
                    >
                        {user.userName}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default MentionSelect;
